import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { getFunctions, httpsCallable } from "firebase/functions";

const Single = ({user}) => {

  const {settingsId} = useParams()


  const [ adminData, setAdminData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)


  const getAdminInfo = () => {

    onSnapshot(doc(db, "admins", settingsId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setAdminData({id: doc.id, ...doc.data(), time: doc.data().timeStamp.toDate().toLocaleString()})
  
    
   });
  
  
  }

  useEffect(()=>{

    getAdminInfo()
    

  }, [])


  const removeAdmin = async() => {

    const functions = getFunctions();
    const callableFunction = httpsCallable(functions, 'removeAdmin');
    const result = await callableFunction({ email: adminData.email });

  }

  const addAdmin = async() => {

    const functions = getFunctions();
    const callableFunction = httpsCallable(functions, 'addAdmin');
    const result = await callableFunction({ email: adminData.email });

     
  }



    const handleStatus = async() => {

      adminData.status === "active" ? removeAdmin() : addAdmin()

      const adminRef = doc(db, "admins", settingsId);
  
      await updateDoc(adminRef, {
  
      status: adminData.status === "active" ? 'inactive' : 'active', 
  
   })
  
    setOpenStatus(false)
  
    }


  
  //   const handleStatus = async() => {
  
      
  //     const adminRef = doc(db, "admins", settingsId);
  
  //     await updateDoc(adminRef, {
  
  //     status: adminData.status === "active" ? 'inactive' : 'active', 
  
  //  })
  
  //   setOpenStatus(false)
  
  //   }
  




  return (
    <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
      
        <div className="top">
            
          <div className="left">

           <div style = {{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingLeft:20, paddingRight:20, }}>

            <h2 className='title'>Admin Information</h2>
             <Link to={`/settings/edit/${settingsId}`} 
                style={{ border: '1px solid gray', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"", cursor:'pointer'}}>
                <span style={{color:'black', fontWeight:'bold'}}>Edit Details</span>
            </Link>

           </div>
        
            <div className='item'>
            {/* <img
                src = {staffData.img}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
            />  */}
               
                <div className="details">
                  <div style={{flexDirection:'row', alignItems:'center'}}>
                    <h3 className='itemTitle'>{adminData.firstname} {adminData.lastname}</h3>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{adminData.email}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Role:</span>
                    <span className='itemValue'>{adminData.role === "adminAccess" ? "Admin" : adminData.role === "subadminAccess" ? "Sub Admin" : "Agency"}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Date:</span>
                    <span className='itemValue'>{adminData.time}</span>
                  </div>
               
                 
                
                </div>

              

            </div>
          </div>
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>

                  <h2 className='title'>Access Status</h2>

                  <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:adminData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                          <span style={{color:'white', fontWeight:'bold'}}>{adminData.status === "active" ? "Active" : "Inactive"}</span>
                  </a>
              

            </div>


          </div>
        
        </div>
      
      </div>
     
    </div>
      <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      />
    </>
 
  )
}

export default Single

